import React, { Component } from 'react';
import {
    Portlet,
    PortletBody,
    PortletHeader,
    PortletHeaderToolbar
} from "../../../partials/content/Portlet";
import UltimatePagination from '../../../partials/layout/PaginationComponent';
import { Container, Row, Col, Card, Badge, Modal, Button, Form } from 'react-bootstrap';
import { MyPropertiesServices } from './MyPropertes.services';
import * as constants from '../../../constants';
import { debounce } from 'throttle-debounce';
import { Link } from 'react-router-dom';
import FilterComponent from '../../../partials/layout/FilterComponent';
import { commonServices } from '../../../commonServices/commonServices';
import { Formik } from 'formik';


export default class MyPropertiesWithScore extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
            myProperties: [],
            selectedProperty: null,
            page: 1,
            offset: 0,
            limit: 10,
            requestedFilters: [
                'propertyManagementStatus'
            ],
            propertyManagementStatus: ['YES']
        }
    }

    async componentDidMount() {
        await this.getAllProperties();
        await this.getPropertyManagers();

    }

    componentWillMount() {
        this.getAllProperties = debounce(800, this.getAllProperties);
    };

    getStatusBadge = (status) => {
        if (!status) return <span className="text-muted">NA</span>;

        const lower = status.toLowerCase();

        if (lower.includes("in process")) {
            return <span className="badge badge-warning">In Process</span>;
        }

        if (lower.includes("discontinued")) {
            return <span className="badge badge-danger">Discontinued</span>;
        }

        if (lower.includes("renewed")) {
            return <span className="badge badge-success">Renewed</span>;
        }
        if (lower.includes("paid")) {
            return <span className="badge badge-success">Paid</span>;
        }
        if (lower.includes("left")) {
            return <span className="badge badge-info">{status}</span>;
        }

        if (lower.includes("overdue")) {
            return <span className="badge badge-danger">{status}</span>;
        }

        return <span className="badge badge-secondary">{status}</span>;
    };

    getScore = (property) => {
        return property.healthScore || 0;
    };

    getRisk = (score) => {
        if (score >= 80) return { label: "Low Risk", variant: "success" };
        if (score >= 60) return { label: "Medium", variant: "warning" };
        return { label: "High Risk", variant: "danger" };
    };

    getPropertyStatusBadge(status) {
        return status === 'OCCUPIED' ? <Badge variant="success" title="Occupied">O</Badge> : <Badge variant="warning" title="Vacant">V</Badge>
    };

    getPropertyManagers = async () => {
        const data = {
            userRoleCodes: ['PROPERTY_MANAGER'],
        }
        const result = await commonServices.getUserListData(data);
        if (result && result.status === 200) {
            const propertyManagers = result.data.users.filter(user =>
                user.userRoleCodes?.includes("PROPERTY_MANAGER")
            );
            await this.setState({ propertyManagers: propertyManagers })
        }
    }

    getAllProperties = async () => {
        this.setState({ isFetching: true });

        const { offset, limit, propertyManagementStatus, cityIds, propertyManagerId, searchQuery, prevQuery, beatsListingIdentifier } = this.state;

        const data = {
            searchQuery,
            cityIds,
            beatsListingIdentifier,
            propertyManagerId: propertyManagerId !== '0' ? propertyManagerId : undefined,
            propertyManagementStatus: propertyManagementStatus?.[0] || undefined,
            include: [
                'PROPERTY_MANAGER'
            ],
            offset,
            limit
        };

        const result = await MyPropertiesServices.getAllPropertiesWithScore(data);
        if (result && result.status === 200) {
            const totalCount = result.headers['x-total-count'];
            const totalPageNo = Math.ceil(totalCount / limit);
            await this.setState({
                myProperties: result.data.houses,
                total: totalPageNo === 0 ? 1 : totalPageNo,
                totalCount
            });
            (prevQuery !== searchQuery) && await this.resetPage();
            await this.setState({ prevQuery: searchQuery })
        }
        this.setState({ isFetching: false });
    };
    // * method to handle page change for pagination
    //     * @param { *} page
    // */
    onPageChange = async (page) => {
        const { limit } = this.state;
        const offset = (limit * (page - 1));
        await this.setState({ page, offset });
        await this.getAllProperties();
    };

    /**
 * Method to reset Pagination
 */
    resetPage = async () => {
        await this.setState({
            page: 1,
            offset: 0,
            // limit: 10,
        })
    };

    handleFilterChildData = async (childData) => {
        if (childData) {
            this.setState({ ...childData })
            await this.resetPage();
            await this.getAllProperties();
            await this.getPropertyManagers();
        }
    }

    // ✅ PROGRESS BAR
    renderProgress = (label, value = 0, max = 100) => {
        const percent = (value / max) * 100;

        return (
            <div className="mb-3">
                <div className="d-flex justify-content-between">
                    <span>{label}</span>
                    <span>{value}/{max}</span>
                </div>

                <div className="progress" style={{ height: "6px" }}>
                    <div
                        className="progress-bar"
                        style={{ width: `${percent}%` }}
                    />
                </div>
            </div>
        );
    };
    render() {

        const { myProperties, totalCount, propertyManagerId, requestedFilters, propertyManagers, propertyManagementStatus, isFetching, selectedProperty, total, page, searchQuery } = this.state;
        // const avgScore = total > 0
        //     ? Math.round(myProperties.reduce((acc, p) => acc + this.getScore(p), 0) / total)
        //     : 0;
        if (searchQuery) {

        }
        let showPagination = false;
        if (total) { showPagination = total !== 0 && total !== 1; }
        const highRisk = myProperties.filter(p => this.getScore(p) < 60).length;

        return (
            <Container fluid>
                <Portlet fluidHeight>
                    <PortletHeader title={`Property Portfolio (${totalCount || 0})`}
                        toolbar={
                            <PortletHeaderToolbar>
                                <Formik
                                    initialValues={{
                                        searchQuery: undefined
                                    }}
                                    onSubmit={
                                        async (values, { setSubmitting }) => {
                                            if (values.searchQuery && values.searchQuery.length > 2) {
                                                await this.setState({ searchQuery: values.searchQuery })
                                                setTimeout(() => {
                                                    this.getAllProperties();
                                                });
                                            } else if ((!values.searchQuery) || (values.searchQuery && values.searchQuery.length < 2)) {
                                                await this.setState({ searchQuery: undefined })
                                                setTimeout(() => {
                                                    this.getAllProperties();
                                                });
                                            }
                                        }

                                    }
                                >
                                    {
                                        ({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) =>
                                        (
                                            <Form className="py-2">
                                                <Form.Text id="searchHelpText" muted>Search by Property Id, Name or by TCF ID</Form.Text>
                                                <Form.Control className="d-inline" type="text" name="searchQuery" placeholder="Type to search..." value={values.searchQuery}
                                                    onChange={
                                                        (e) => {
                                                            handleSubmit(e);
                                                            handleChange(e);
                                                        }
                                                    }
                                                />
                                            </Form>
                                        )
                                    }
                                </Formik>
                                <span className="px-2">OR</span>
                                <Formik
                                    initialValues={{
                                        beatsListingIdentifier: undefined
                                    }}
                                    onSubmit={
                                        async (values, { setSubmitting }) => {
                                            if (values.beatsListingIdentifier && values.beatsListingIdentifier.length > 2) {
                                                await this.setState({ beatsListingIdentifier: values.beatsListingIdentifier })
                                                setTimeout(() => {
                                                    this.getAllProperties();
                                                });
                                            } else if ((!values.beatsListingIdentifier) || (values.beatsListingIdentifier && values.beatsListingIdentifier.length < 2)) {
                                                await this.setState({ beatsListingIdentifier: undefined })
                                                setTimeout(() => {
                                                    this.getAllProperties();
                                                });
                                            }
                                        }
                                    }>
                                    {
                                        ({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) =>
                                        (
                                            <Form className="py-2">
                                                <Form.Text id="BeatsHelpText" muted>Search using Beats Listing ID.</Form.Text>
                                                <Form.Control className="d-inline" type="text" name="beatsListingIdentifier" placeholder="Type to search..." value={values.beatsListingIdentifier}
                                                    onChange={
                                                        (e) => {
                                                            handleSubmit(e);
                                                            handleChange(e);
                                                        }
                                                    }
                                                />
                                            </Form>
                                        )}
                                </Formik>
                            </PortletHeaderToolbar>
                        }
                    />

                    <PortletBody>
                        <Card>
                            <FilterComponent
                                requestedFilters={requestedFilters}
                                propertyManagers={propertyManagers}
                                propertyManagerId={propertyManagerId}
                                recordsPerPage={constants.RECORDS_PER_PAGE}
                                selectedRecordValue={this.state.limit}
                                filterParentCallback={this.handleFilterChildData}
                                propertyManagementStatus={propertyManagementStatus}
                                isMyProperties={true} />
                            <Card.Header>
                                <Row>
                                    {/* <Col md={1}><b>ID</b></Col> */}
                                    <Col md={3}><b>Property Name</b></Col>
                                    <Col md={2}><b>Manager</b></Col>
                                    <Col md={2}><b>Health Score</b></Col>
                                    <Col md={1}><b>Rent Status</b></Col>
                                    <Col md={2}><b>Renewal</b></Col>
                                    <Col md={1}><b>Risk</b></Col>
                                    {/* <Col md={1}><b>Issues</b></Col> */}
                                </Row>
                            </Card.Header>

                            <Card.Body className="p-0">

                                {isFetching && <p className="m-3">{constants.LOADING_DATA}</p>}

                                {!isFetching && myProperties.length === 0 &&
                                    <p className="m-3">{constants.ZERO_DATA}</p>
                                }

                                {!isFetching && myProperties.map(property => {

                                    const score = this.getScore(property);
                                    const risk = this.getRisk(score);

                                    return (
                                        <Row
                                            key={property.houseId}
                                            className="px-3 py-3 align-items-center table-row"
                                            onClick={() => this.setState({ selectedProperty: property })}
                                        >
                                            {/* <Col md={1}>P{property.houseId}</Col> */}

                                            <Col md={3} className="d-flex flex-row"><span className="pr-3">{this.getPropertyStatusBadge(property.occupancyStatus || 'CLOSED')}</span>
                                                <span>{property.formattedHouseName || property.propertyName} <br />
                                                    {property.propertyManager ? <span className="small text-muted">PM: {property.propertyManager && property.propertyManager.fullName}</span> : <span className="small text-warning">PM: Not Assigned</span>}
                                                </span>
                                            </Col>

                                            <Col md={2}>
                                                {property.propertyManager?.fullName || "-"}
                                            </Col>

                                            <Col md={2}>
                                                <b>{score}</b>
                                                <div className="progress mt-1" style={{ height: "5px" }}>
                                                    <div
                                                        className="progress-bar"
                                                        style={{ width: `${score}%` }}
                                                    />
                                                </div>
                                            </Col>

                                            <Col md={1}>
                                                {this.getStatusBadge(property.rentStatus)}
                                            </Col>

                                            <Col md={2}>
                                                {this.getStatusBadge(property.renewalStatus)}
                                            </Col>
                                            <Col md={1}>
                                                <Badge variant={risk.variant}>{risk.label}</Badge>
                                            </Col>
                                            <Col md={1}>
                                                <Link to={`/property-profile/${property.houseId}`}>
                                                    <Button size='sm' variant='clean'><i className="flaticon-home-1 text-primary"></i></Button>
                                                </Link>
                                            </Col>
                                        </Row>
                                    );
                                })}

                            </Card.Body>
                        </Card>

                        {selectedProperty && (
                            <Modal
                                show={!!selectedProperty}
                                onHide={() => this.setState({ selectedProperty: null })}
                                size="lg"
                                centered
                            >
                                <Modal.Header closeButton>
                                    <Modal.Title>
                                        {selectedProperty.formattedHouseName || selectedProperty.propertyName}
                                    </Modal.Title>
                                </Modal.Header>

                                <Modal.Body>

                                    <p className="text-muted mb-2">
                                        PM: {selectedProperty.propertyManager?.fullName || "No Property Manager"}
                                    </p>

                                    <h3 className="mb-3">
                                        {this.getScore(selectedProperty)}/100
                                    </h3>

                                    {selectedProperty.detailedBreakdown && (
                                        <>
                                            <h6 className="mb-3">Score Breakdown</h6>

                                            {this.renderProgress(
                                                "Operations",
                                                selectedProperty.detailedBreakdown.operationsExecution?.score,
                                                45
                                            )}

                                            {this.renderProgress(
                                                "Financial",
                                                selectedProperty.detailedBreakdown.financialDiscipline?.score,
                                                15
                                            )}

                                            {this.renderProgress(
                                                "Customer",
                                                selectedProperty.detailedBreakdown.customerExperience?.score,
                                                20
                                            )}

                                            {this.renderProgress(
                                                "Renewal",
                                                selectedProperty.detailedBreakdown.renewalPerformance?.score,
                                                20
                                            )}
                                        </>
                                    )}

                                </Modal.Body>

                                <Modal.Footer>
                                    <Button
                                        variant="secondary"
                                        onClick={() => this.setState({ selectedProperty: null })}
                                    >
                                        Close
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                        )}
                        {/* Code for pagination */}
                        {!isFetching && showPagination && showPagination && <UltimatePagination
                            currentPage={page}
                            totalPages={total}
                            onChange={this.onPageChange}
                            boundaryPagesRange={0}
                            hidePreviousAndNextPageLinks={true}
                            hideFirstAndLastPageLinks={page !== 1 && page !== total ? false : true}
                        />}
                    </PortletBody>
                </Portlet>
            </Container>
        );
    }
}